var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "instruction-comment-item py-1.5 px-3 rounded hover:bg-hover-state cursor-pointer",
      class: [_vm.editOpened ? "bg-hover-state" : "bg-pure-white"],
      attrs: { id: "instruction-comment-item" }
    },
    [
      !_vm.editOpened
        ? _c("div", { staticClass: "comment-body flex flex-col gap-1" }, [
            _c(
              "div",
              {
                staticClass: "flex items-center justify-between gap-4 truncate"
              },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2 truncate" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "h-6 w-6 flex-shrink-0 flex items-center justify-center rounded-full bg-success-100"
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-success-400",
                          attrs: {
                            title: _vm.comment.user_name || "Deleted user",
                            text: (_vm.comment.user_name || "Deleted user").at(
                              0
                            )
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.comment.user_name
                      ? _c("BlTextSubtitle3", {
                          staticClass: "italic",
                          attrs: { title: "Deleted user", text: "Deleted user" }
                        })
                      : _c("BlTextSubtitle3", {
                          staticClass: "text-slate-800 truncate",
                          attrs: { text: _vm.comment.user_name }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-1" },
                  [
                    _vm.comment.is_edited
                      ? _c("BlTextBody2", {
                          staticClass: "text-slate-600",
                          attrs: { text: "Edited" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "text-slate-600",
                      attrs: {
                        text: _vm.displayDate(
                          _vm.comment.updated_at,
                          "DD/MM/YY"
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "text-slate-600",
                      attrs: {
                        text: _vm.displayDate(_vm.comment.updated_at, "HH:mm")
                      }
                    }),
                    _vm._v(" "),
                    _vm.comment.user_id === _vm.currentUser.id
                      ? _c("div", { staticClass: "comment-action" }, [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-1" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "h-5.5 w-5.5 flex items-center justify-center rounded hover:bg-slate-500 cursor-pointer",
                                  attrs: { title: "Remove comment" },
                                  on: {
                                    click: function($event) {
                                      _vm.deleteOpened = true
                                    }
                                  }
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "w-4 h-4",
                                    attrs: { icon: "delete", color: "slate-6" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "h-5.5 w-5.5 flex items-center justify-center rounded hover:bg-slate-500 cursor-pointer",
                                  attrs: { title: "Edit comment" },
                                  on: {
                                    click: function($event) {
                                      _vm.editOpened = true
                                    }
                                  }
                                },
                                [
                                  _c("BlIcon", {
                                    staticClass: "w-4 h-4",
                                    attrs: { icon: "edit", color: "slate-6" }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pl-8 flex" }, [
              _c("div", {
                staticClass: "text-slate-700 text-sm",
                domProps: { innerHTML: _vm._s(_vm.comment.body) }
              })
            ])
          ])
        : _c("div", { staticClass: "w-full flex gap-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-6 w-6 flex-shrink-0 flex items-center justify-center rounded-full bg-success-100"
              },
              [
                _c("BlTextBody2", {
                  staticClass: "text-success-400",
                  attrs: {
                    title: _vm.comment.user_name || "Deleted user",
                    text: (_vm.comment.user_name || "Deleted user").at(0)
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.editOpened
              ? _c(
                  "div",
                  { staticClass: "pb-px w-full relative" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "absolute top-2 right-2 flex items-center gap-2"
                      },
                      [
                        _c("BlInputButton", {
                          attrs: {
                            type: "plain",
                            dense: "",
                            label: "Cancel",
                            loading: _vm.submitLoading
                          },
                          on: {
                            clicked: function($event) {
                              _vm.editOpened = false
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlInputButton", {
                          attrs: {
                            label: "Save",
                            dense: "",
                            disabled: _vm.isDisabledSubmit,
                            loading: _vm.submitLoading
                          },
                          on: { clicked: _vm.onUpdate }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("VueEditor", {
                      staticClass: "blum-editor",
                      attrs: {
                        "editor-toolbar": _vm.customToolbar,
                        placeholder: "Comment this instruction"
                      },
                      model: {
                        value: _vm.bodyInput,
                        callback: function($$v) {
                          _vm.bodyInput = $$v
                        },
                        expression: "bodyInput"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete comment",
              description:
                "You are about to delete the comment. Are you sure you want to proceed? This action is irreversible.",
              label: "Delete",
              type: "error",
              disabled: _vm.deleteLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onRemove
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b686157", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b686157","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/prospectPanel/instructionComment/Item.vue
// module id = null
// module chunks = 